module.exports = __webpack_public_path__ + "static/0028-f1c92b0847ec532552e3f99185b1deae.png";